import React, { useEffect } from "react";
import { Col, Flex, InputNumber, Row, Switch } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Button, Select } from "antd";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import styles from "./AutoCredit.module.scss";
import {
  getAdminSubscriptionsAction,
  updateSubscriptionPlanAutoCreditByIdAction,
} from "../../../../../../redux/services/service-provider-subscriptions/serviceProviderSubscriptionsServices";
import { routes } from "../../../../../../constants";
import { baseRouteMakerForSuperAdmin } from "../../../../../../constants/routeConsts";

const AutoCredit = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const [status, setStatus] = useState(false);
  /* form dependencies */


  useEffect(() => {
    getAdminSubscriptionsAction(setLoading);
  }, []);


  const handleViewList = () => {
    navigate(baseRouteMakerForSuperAdmin(routes.AUTO_CREDIT_LIST))
  }

  const onStatusChanged = (value) => {
    setStatus(value)
  }

  /* Form submit handler */
  const onSubmit = (values) => {
    let dataToBeSent = {
      subscription_plan_code: values?.subscriptionType, // PREMIUM,ELITE-PREMIUM
      auto_credit_threshold_count: values?.autoCreditThreshold,
      auto_credit_period: values?.autoCreditPeriod,
      is_active: values?.status,
    };

    dispatch(
      updateSubscriptionPlanAutoCreditByIdAction(dataToBeSent, setLoading)
    );
  };
  /* Form submit handler */

  return (
    <div className={styles.elitePremiumContainer}>
      <Flex vertical gap="2rem">
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                name="subscriptionType"
                label={
                  <RequiredLabel
                    text={t("Modules.AutoCredit.subscriptionType")}
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.AutoCredit.pleaseSelectSubscriptionType"
                    ),
                  },
                ]}
              >
                <Select
                  loading={selectListLoader}
                  options={[
                    { value: "ELITE-PREMIUM", label: "Elite Premium" },{ value: "PREMIUM", label: "Premium" }
                  ]}
                  placeholder={t("Modules.AutoCredit.selectSubscriptionType")}
                />
              </Form.Item>
            </Col>
            <Col span={14}>
              <Form.Item
                name="status"
                label={
                  <RequiredLabel
                    text={t("Modules.AutoCredit.status")}
                    required={false}
                  />
                }
              >
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  checked={status}
                  onClick={(e) => onStatusChanged(e)}
                />
              </Form.Item>
            </Col>
            <Col span={2}>
          <Button
              type="primary"
              loading={loading}
              disabled={loading}
              style={{ marginTop: "10px" }}
              onClick={(e) => handleViewList(e)}
            >
              {t("CommonUtils.logs")}
            </Button>
          </Col>
          </Row>

          <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.AutoCredit.autoCreditThreshold")}
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.AutoCredit.pleaseEnterAutoCreditThreshold"
                    ),
                  },
                ]}
                name="autoCreditThreshold"
              >
                <InputNumber
                  style={{ width: "100%" }}
                  type="number"
                  controls={false}
                  placeholder={t("Modules.AutoCredit.enterAutoCreditThreshold")}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.AutoCredit.autoCreditPeriod")}
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.AutoCredit.pleaseEnterAutoCreditPeriod"
                    ),
                  },
                ]}
                name="autoCreditPeriod"
              >
                <InputNumber
                  style={{ width: "100%" }}
                  type="number"
                  controls={false}
                  placeholder={t("Modules.AutoCredit.enterAutoCreditPeriod")}
                />
              </Form.Item>
            </Col>

            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("CommonUtils.submit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Flex>
    </div>
  );
};

export default AutoCredit;
